export const ProjetosEnum = {
  ISEVEN: 1,
  MODULUS: 2,
  PLATAFORMA_CLIENTE: 3,
  PLATAFORMA_CRM: 4,
  HUB_UI: 5
};
